// NPM imports

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'lodash-es';
// Module imports

import Map from './components/Map/General';
import Filter from '../../components/Filter';
import DeliveryStatus from '../../components/DeliveryStatus';

import {
  deliveryStatusTypes,
  storeKeys,
} from '../../../../redux/delivery-status';

// Component

import './styles.css';

class DashboardGeneralRealTime extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveryStatusActiveTab: 1,
      mapCenter: {
        lat: -14.238962,
        lng: -51.913029,
      },
      activeNf: {
        isVisible: false,
        lat: 0,
        lng: 0,
        nfId: 0,
      },
    };
  }

  _changeTab = (type, performanceStatusCode) => {
    this.setState({
      deliveryStatusActiveTab: performanceStatusCode,
    });
  };

  _setActiveNf = ({
    centerLat,
    centerLng,
    isVisible,
    lat,
    lng,
    landmark,
    lastUpdate,
    nfId,
    data,
    expanded,
  }) => {
    this.setState({
      mapCenter: {
        lat: centerLat,
        lng: centerLng,
      },
      activeNf: {
        isVisible,
        lat,
        lng,
        landmark,
        lastUpdate,
        nfId,
        data,
        expanded,
      },
    });
  };

  _getVehiclePosition = (activeRow) => {
    const {
      onTime, lateRisk, late, deliveryData,
    } = this.props;

    const { activeNf } = this.state;

    const allDeliveries = [...onTime, ...lateRisk, ...late];
    const selectedPosition = allDeliveries.find(el => el.nfId === activeRow.id);
    const nfListGroup = groupBy(deliveryData, 'tms.plate');

    if (activeNf.isVisible) {
      this._hideMarkerTooltip();
    } else {
      this._setActiveNf({
        centerLat: selectedPosition.iipoS_Latitude,
        centerLng: selectedPosition.iipoS_Longitude,
        isVisible: true,
        lat: selectedPosition.iipoS_Latitude,
        lng: selectedPosition.iipoS_Longitude,
        landmark: selectedPosition.iipoS_Landmark,
        lastUpdate: selectedPosition.iipoS_TimePosition,
        nfId: selectedPosition.nfId,
        data: nfListGroup[activeRow.tms.plate],
        expanded: nfListGroup[activeRow.tms.plate].findIndex(el => el.id === activeRow.id),
      });
    }
  };

  // TODO - Levar essa função e states para a camada de cima
  _renderMarkerTooltip = (e, location) => {
    this._setActiveNf({
      centerLat: e.latLng.lat(),
      centerLng: e.latLng.lng(),
      isVisible: true,
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
      landmark: location.iipoS_Landmark,
      lastUpdate: location.iipoS_TimePosition,
      nfId: location.nfList && location.nfList[0].id,
      data: location.nfList ? location.nfList : [],
      expanded: 0,
    });
  };

  _hideMarkerTooltip = () => {
    this.setState({
      activeNf: {
        isVisible: false,
      },
    });
  };

  render() {
    const { mapCenter, activeNf } = this.state;
    return (
      <div className="DashboardRealTime">
        <Map
          zoom={5}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDNV7mHyjuTm0VC8ZZnW90OTZWrvBnXIaw&v=3.exp&libraries=geometry,drawing,places"
          loadingElement={<div className="DashboardRealTime__loading-el" />}
          containerElement={<div className="DashboardRealTime__container-el" />}
          mapElement={<div className="DashboardRealTime_General__map-el" />}
          deliveryStatusActiveTab={this.state.deliveryStatusActiveTab}
          mapCenter={mapCenter}
          renderMarkerTooltip={this._renderMarkerTooltip}
          hideMarkerTooltip={this._hideMarkerTooltip}
          activeNf={activeNf}

          notPassCompanyId
        />
        <div className="DashboardRealTime__filters">
          <Filter
            applyOnDeliveryStatus

            notPassCompanyId
            customerMinimumDigits={3}
            shippingGroupFilter
            customerFilter
            deliveryStatusActiveTab={this.state.deliveryStatusActiveTab}
          />
          <DeliveryStatus
            notPassCompanyId
            onTabChange={this._changeTab}
            type={deliveryStatusTypes.ALL}
            collapsible
            storeKey={storeKeys.REAL_TIME}
            
            onGetVehiclePosition={this._getVehiclePosition}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    onTime: state.dashboardRealTime.onTime.data,
    lateRisk: state.dashboardRealTime.lateRisk.data,
    late: state.dashboardRealTime.late.data,
    deliveryData: state.deliveryStatus.realTime.deliveries,
  };
}

export default connect(mapStateToProps)(DashboardGeneralRealTime);
